/** */
import React, { useState } from 'react';
import { useMailingReportService } from 'hooks/mailing/report';
import { Button } from 'app/shared/button';
import { MultiSelect } from 'app/shared/select';
import styles from './generate.module.css';

const now = new Date();

const PERIOD_OPTIONS = Array.from({ length: 6 }, (_, i) => {
  const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
  const month = d.getMonth() + 1;
  const year = d.getFullYear();
  return {
    label: d.toLocaleString('default', { month: 'long', year: 'numeric' }),
    value: { month, year }
  };
});

export const ReportGenerationModal = () => {
  const { generateMonthlyReport } = useMailingReportService();
  const [period, setPeriod] = useState(PERIOD_OPTIONS[0]);
  const [loading, setLoading] = useState(false);
  const [report_url, setReportUrl] = useState('');

  const handlePeriodChange = (selected) => {
    setPeriod(selected);
    setReportUrl('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    setReportUrl('');
    const url = await generateMonthlyReport(period.value);
    setLoading(false);
    if (!url) return;

    setReportUrl(url);
  };

  return (
    <div className={styles.form}>
      <p className={styles.description}>
        Select a month to generate a full performance report with AI-generated insights.
      </p>

      {report_url && (
        <div className={styles.notification}>
          <span>{period.label} report is ready.</span>
          <a href={report_url} target="_blank" rel="noreferrer" className={styles.notificationLink}>
            View report →
          </a>
        </div>
      )}

      <div className={styles.fields}>
        <MultiSelect
          label="Period"
          options={PERIOD_OPTIONS}
          value={period}
          onChange={handlePeriodChange}
          isSorted={false}
        />
      </div>

      <Button text="Generate Report →" onClick={handleSubmit} loading={loading} />
    </div>
  );
};
